"use strict";

var _preact = require("preact");
var Breadcrumb = function Breadcrumb(props) {
  var getFolder = props.getFolder,
    title = props.title,
    isLast = props.isLast;
  return (0, _preact.h)(_preact.Fragment, null, (0, _preact.h)("button", {
    type: "button",
    className: "uppy-u-reset",
    onClick: getFolder
  }, title), !isLast ? ' / ' : '');
};
module.exports = function (props) {
  var _getFolder = props.getFolder,
    title = props.title,
    breadcrumbsIcon = props.breadcrumbsIcon,
    directories = props.directories;
  return (0, _preact.h)("div", {
    className: "uppy-Provider-breadcrumbs"
  }, (0, _preact.h)("div", {
    className: "uppy-Provider-breadcrumbsIcon"
  }, breadcrumbsIcon), directories.map(function (directory, i) {
    return (0, _preact.h)(Breadcrumb, {
      key: directory.id,
      getFolder: function getFolder() {
        return _getFolder(directory.id);
      },
      title: i === 0 ? title : directory.title,
      isLast: i + 1 === directories.length
    });
  }));
};